import { IAddressAutocomplete } from '@cbgms/api/modules/miscellaneous/address/search'
import { ILocationResult } from './locationResultModel'

export function mapAddressAutocompleteToLocationResults(input: IAddressAutocomplete[]): ILocationResult[] {
  return input.map(i => {
    return {
      id: i.AutoCompleteID,
      text: i.AutoCompleteText,
      singleResult: i.SingleResult
    }
  })
}
